import { Box, Typography, styled } from "@mui/material";
import NumberFormats from "components/NumberFormats";

export function MarginCard({ title, usdt, toman, children, showPrice = false }) {

  return (
    <Box pl={{ xs: 3, md: 0 }}>
      <Box display={"flex"} alignItems={"center"} marginBottom={2.3} gap={1}>
        <Typography
          variant="h6"
          color="text.primary"
          fontWeight={400}
        >
          {title}
        </Typography>

        {children}
      </Box>

      <BoxCoin>
        <UsdtText variant="h1" color="text.primary" fontWeight={600}>
          {!showPrice ? <Typography component={"span"} variant="h1" fontFamily={"none !important"}>*******</Typography> : <NumberFormats value={usdt} />}
          <Typography component="small" fontWeight={500}>
            USDT
          </Typography>
        </UsdtText>
      </BoxCoin>

      <TomanBox>
        <Typography variant="h5" color="text.primary" fontWeight={400}>
          {!showPrice ? <Typography component={"span"} variant="h5" fontFamily={"none !important"}>*******</Typography> : <NumberFormats value={toman} />}
          <Typography component="small" fontWeight={300}>
            TOMAN
          </Typography>
        </Typography>
      </TomanBox>
    </Box>
  );
}

const BoxCoin = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(1.3),
  img: {
    width: "30px",
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1.5)
  },
  small: {
    fontSize: "20px",
    marginLeft: theme.spacing(0.7),
    color: theme.palette.text.secondary
  },
}));

const TomanBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(1.3),
  img: {
    width: "14px",
    margin: theme.spacing(0, 1, 0.5, 3.5)
  },
  small: {
    fontSize: "12px",
    marginLeft: theme.spacing(0.7),
    color: theme.palette.text.secondary
  },
}));

const UsdtText = styled(Typography)(({ theme }) => ({
  fontSize: "40px",
  [theme.breakpoints.down('md')]: {
    fontSize: "28px"
  }
}));

export default MarginCard;
